// ----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
import { Provider } from '../core/provider';
export class StaticProvider extends Provider {
    constructor(name, instrumentService){
        super(name, instrumentService);
    }
}
